import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { I18n, translate } from '@td/shared_utils';

import MedicationNdcLookup from './medication-ndc-lookup';
import { Medication } from '../../types/medication';
import CollapsibleSection from '../../../components/collapsible/collapsible-section';
import { formattedDrugName } from '../../utils/drug';

const MedicationIdentifiers = ({ drug, searchTerm }) => {
  return (
    <section>
      <h2>
        <I18n scope="medication_formularies.details.identifiers" text="title" />
      </h2>
      <table className="fields">
        <tbody>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.identifiers.labels" text="name" />
            </th>
            <td>
              <ul>
                <li
                  className={classnames({
                    'font-bold': !searchTerm || searchTerm === formattedDrugName(drug.genericDrug.drugName, 'GENERIC')
                  })}
                >
                  {formattedDrugName(drug.genericDrug.drugName, 'GENERIC')}
                </li>

                {drug.brandNameDrugs.map(brandNameDrug => (
                  <li
                    key={brandNameDrug.drugName}
                    className={classnames({
                      'font-bold': searchTerm === formattedDrugName(brandNameDrug.drugName, 'BRAND')
                    })}
                  >
                    {brandNameDrug.drugName}
                  </li>
                ))}
              </ul>
            </td>
          </tr>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.identifiers.labels" text="drug_id" />
            </th>
            <td>{drug.drugId}</td>
          </tr>
          <tr>
            <th>
              <I18n scope="medication_formularies.details.identifiers.labels" text="mmdc" />
            </th>
            <td>{drug.drugForms.map(form => form.mmdc).join(', ')}</td>
          </tr>
          <tr>
            <td colSpan="2">
              <CollapsibleSection
                title={translate(null, 'medication_formularies.details.identifiers.labels', 'ndc')}
                collapsedDefault
              >
                <table className="fields">
                  <tbody>
                    <tr>
                      <th />
                      <td>
                        <MedicationNdcLookup drug={drug} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CollapsibleSection>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

MedicationIdentifiers.propTypes = {
  drug: Medication,
  searchTerm: PropTypes.string
};

export default MedicationIdentifiers;
